import { Component, input } from '@angular/core';
import { ColumnRendererComponentV3 } from '@gea/digital-ui-lib';
import { Annunciation } from '@shared/models';

import { ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'gea-hrt-text-solved-render',
  template: ` <span>{{ '(' + rowData()?.countSolved + ')' }}</span> `,
})
export class TextSolvedRenderComponent implements ColumnRendererComponentV3<Annunciation> {
  readonly rowData = input<Annunciation>();
}
